import ZCollapseItem from '../collapse/collapse-item.vue'

ZCollapseItem.install = function(app) {
  app.component(ZCollapseItem.name, ZCollapseItem)
}

export default ZCollapseItem